<template>
  <div class="preview-card">
    <div class="preview-card__image-wrapper">
      <img :src="image" :alt="alt"/>
    </div>
    <div class="preview-card__text">{{text}}</div>
  </div>
</template>

<script>
  export default {
    name: "UXPreviewCard",
    props: {
      image: String,
      alt: String,
      text: String,
    },
    computed: {}
  };
</script>
